import { motion } from "framer-motion";
import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import Menu from "../Menu/Menu";
import MobileMenu from "../MobileMenu/MobileMenu";
import "./Header.css";
import logo from "../../assets/student.png";
import AOS from "aos";
import "aos/dist/aos.css";
import ButtonCommon from "../ButtonCommon/ButtonCommon";
import { Fragment } from "react";
import { useEffect } from "react";
const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0,
  });
  const [cursorVariant, setCursorVariant] = useState("default");

  AOS.init({
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 500,
  });

  // useEffect(() => {
  //   const mouseMove = (e) => {
  //     setMousePosition({
  //       x: e.clientX,
  //       y: e.clientY,
  //     });
  //   };
  //   window.addEventListener("mousemove", mouseMove);
  //   return () => {
  //     window.removeEventListener("mousemove", mouseMove);
  //   };
  // }, []);

  const textEnter = () => setCursorVariant("text");
  const textLeave = () => setCursorVariant("default");

  // const variants = {
  //   default: {
  //     x: mousePosition.x - 16,
  //     y: mousePosition.y - 16,
  //   },
  //   text: {
  //     height: 100,
  //     width: 100,
  //     x: mousePosition.x - 50,
  //     y: mousePosition.y - 50,
  //     backgroundColor: "#2696e8",
  //     color: "#fff",
  //     mixBlendMode: "difference",
  //   },
  // };

  return (
    <Fragment>
      {/* <motion.div
        className="cursor"
        variants={variants}
        animate={cursorVariant}
      ></motion.div> */}

      <div className=" w-full  sticky top-0  mx-auto   bg-own-primary z-50 py-4 border-b-[1px] border-own-border-color border-opacity-10">
        <div className=" MyContainer flex justify-between items-center">
          <div className="logo text-xl font-bold tracking-wide">
            <motion.a
              href="/"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className=" text-light_dark tracking-widest flex items-center cursor-pointer "
            >
              <img className="-mt-4 mr-2" width="40px" src={logo} alt="" />
              <span className="text-own-secondary">Zayan</span>
            </motion.a>
          </div>
          <div className="flex gap-4 headerMenu items-center ">
            <Menu
              textLeave={textLeave}
              textEnter={textEnter}
              menuClass="menuForDesktop"
            />
            <ButtonCommon>Download CV</ButtonCommon>
          </div>
          <div className="MenIcons">
            <FiMenu
              onClick={() => setShowMenu(!showMenu)}
              className="text-3xl text-sweet_red cursor-pointer"
            />
          </div>
          <motion.div
            animate={
              showMenu
                ? { opacity: 1, x: "0" }
                : { left: "-350px", opacity: 0.75, x: "-100%" }
            }
            className={showMenu ? "mobileMenu active " : "mobileMenu"}
          >
            {showMenu ? (
              <MobileMenu
                deraction={true}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
              />
            ) : null}
          </motion.div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
